import { http } from "@/utils/index";

// 查询所有文件夹
export function listFolder() {
  return http.request("get", "/document-folder/list");
}

// 根据父ID查询子文件夹
export function listFolderByParentId(parentId) {
  return http.request("get", "/document-folder/list/" + parentId);
}

// 分页查询文件列表
export function pageDocument(query) {
  return http.request("get", "/document/page", {
    params: query
  });
}

// 查询文件列表
export function listDocument() {
  return http.request("get", "/document/list");
}

// 根据文件夹ID查询文件
export function listDocumentByFolderId(folderId) {
  return http.request("get", "/document/list/" + folderId);
}

// 查询文件详细
export function getDocument(id) {
  return http.request("get", "/document/" + id);
}

// 下载文件URL
export function getDownloadUrl(id) {
  return "/document/download/" + id;
}
